/** Claves alineadas con `key` de ítems del menú lateral (useAdminMenuLayout). */
export type AdminModuleKey = string;

export type AdminModuleOption = {
  key: AdminModuleKey;
  label: string;
  group?: string;
};

export const ADMIN_MODULE_OPTIONS: AdminModuleOption[] = [
  { key: "/orders", label: "Pedidos" },
  { key: "/support-tickets", label: "Mensajes" },
  { key: "/products", label: "Productos" },
  { key: "/popular-products", label: "Productos populares" },
  { key: "/promotions", label: "Promociones", group: "Ofertas" },
  { key: "/promotions?promoType=2x1", label: "Combo 2x1", group: "Ofertas" },
  { key: "/promotions?promoType=3x2", label: "Combo 3x2", group: "Ofertas" },
  { key: "/rules-fifty-off/", label: "Rollos 50%", group: "Ofertas" },
  { key: "/rules-sushi-lunch/", label: "Sushi Lunch", group: "Ofertas" },
  { key: "/stores", label: "Sedes" },
  { key: "/sauces", label: "Salsas" },
  { key: "/accompaniments", label: "Acompañamientos" },
  { key: "/productCategories", label: "Categorías" },
  { key: "/listCustomerGroups", label: "Grupos de clientes" },
  { key: "/discountCode", label: "Cupones" },
  { key: "/ratings", label: "Calificaciones" },
  { key: "/walletBalance", label: "Billetera → Balance", group: "Billetera" },
  { key: "/walletMovements", label: "Billetera → Movimientos", group: "Billetera" },
  { key: "/walletBonus", label: "Billetera → Bonos", group: "Billetera" },
  { key: "/banners", label: "Banners" },
  { key: "/cms", label: "CMS" },
  { key: "/users", label: "Usuarios del sistema" },
  { key: "/clientes", label: "Clientes" },
  { key: "/domiciliarios", label: "Domiciliarios" },
  { key: "/tax", label: "Configuración → IVA", group: "Configuración" },
  { key: "/cities", label: "Configuración → Ciudades", group: "Configuración" },
  { key: "/states", label: "Configuración → Estados", group: "Configuración" },
  { key: "/shipping-rates", label: "Configuración → Tarifas de envío", group: "Configuración" },
  { key: "/systemVariables", label: "Configuración → Variables del sistema", group: "Configuración" },
  { key: "/configuration-cashback", label: "Configuración → Cashback", group: "Configuración" },
];

/** Vendedor sin módulos personalizados: solo pedidos y mensajes. */
export const DEFAULT_SELLER_MODULES: AdminModuleKey[] = [
  "/orders",
  "/support-tickets",
];

export const ALL_ADMIN_MODULE_KEYS: AdminModuleKey[] = ADMIN_MODULE_OPTIONS.map(
  (m) => m.key
);
